export class FilterModel {
    END_DATE :Date;
    START_DATE :Date;
  }
  